import { Routes, Route } from '@angular/router';

import { EmptyShellComponent } from './empty-shell.component';

/**
 * Provides helper methods to create routes.
 */
export class EmptyShell {
  /**
   * Creates routes using the shell component and authentication.
   * @param routes The routes to add.
   * @return The new route using shell as the base.
   */
  static childRoutes(routes: Routes): Route {
    return {
      path: '',
      component: EmptyShellComponent,
      children: routes,
      // canActivate: [AuthenticationGuard],//no need to authenticate empty shell, do not run protected routes through empty shell.
      // Reuse ShellComponent instance when navigating between child views
      data: { reuse: true },
    };
  }
}
